import React from "react";

/**
 * Loading placeholder.
 *
 * Deliberately mirrors the skeleton in public/index.html so the handover from
 * "HTML painted before React booted" to "React rendering" is invisible - same
 * blocks, same positions, nothing flashes or jumps.
 *
 * This replaced <div id="preloader"> , whose CSS animates a ring from 10px to
 * 72px and fades it out. Caught at its first frame that reads as a small blue
 * dot in the middle of an empty page, which looked like a fault rather than
 * loading. The #preloader styles are still used by the checkout and booking
 * screens, so they remain in App.css.
 */
function Loader() {
  return (
    <div className="app-skeleton" aria-label="Loading" role="status">
      <div className="sk-header">
        <div className="sk sk-logo" />
        <div className="sk-nav">
          <div className="sk sk-navitem-wide" />
          <div className="sk sk-navitem" />
          <div className="sk sk-navitem" />
          <div className="sk sk-pill" />
        </div>
      </div>
      <div className="sk-body">
        <div className="sk sk-hero" />
        <div className="sk-row">
          <div className="sk sk-card" />
          <div className="sk sk-card" />
          <div className="sk sk-card" />
          <div className="sk sk-card" />
        </div>
      </div>
    </div>
  );
}

export default Loader;
